type UsageEventType = "focus" | "blur"

declare global {
  interface Window {
    SalesforceInteractions?: {
      sendEvent(event: { interaction: Record<string, unknown> }): void
    }
  }
}

export function loadDataCloudSdk(url: string): void {
  if (document.querySelector(`script[src="${url}"]`)) {
    return
  }
  const script = document.createElement("script")
  script.src = url
  document.head.prepend(script)
}

export function sendTradeDeskUsageEvent(
  usageType: UsageEventType,
  agentUserId: string
): void {
  window.SalesforceInteractions?.sendEvent({
    interaction: {
      name: "tradeDeskUsage",
      eventType: "tradeDeskUsage",
      usageType,
      agentUserId,
    },
  })
}
